export class ResetPasswordEmailModel {
  email: string;
  requestInfo: {
    status: string;
    timeRequest: string;
    passText: string;
    timeExpiry: string;
  };

  constructor(data: APIEmailRecoveryResponse) {
    this.email = data?.email ?? '';
    this.requestInfo = {
      status: data?.request_info?.status ?? '',
      timeRequest: data?.request_info?.time_request ?? '',
      passText: data?.request_info?.pass_text ?? '',
      timeExpiry: data?.request_info?.time_expiry ?? '',
    };
  }

  static fromAPI(data: APIEmailRecoveryResponse): ResetPasswordEmailModel {
    return new ResetPasswordEmailModel(data);
  }
}

interface APIEmailRecoveryResponse {
  email: string;
  request_info: {
    status: string;
    time_request: string;
    pass_text: string;
    time_expiry: string;
  };
}
